// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__newButton--YteMz {
  background-color: #fff;
  border-radius: 0.5rem;
  cursor: pointer;
  outline: none;
  border: none;
  color: #313235;
  height: 42px;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: none;
  text-decoration: none;
}
.style__newButton--YteMz:hover {
  background-color: #fff !important;
  text-decoration: underline;
}
.style__newButton--YteMz:focus {
  background-color: #fff !important;
  text-decoration: underline;
}
.style__newButton--YteMz:active {
  background-color: #fff !important;
  text-decoration: underline;
}
.style__button--RnM4U {
  background-color: #26c1f3;
  border-radius: 0.5rem;
  cursor: pointer;
  outline: none;
  border: none;
  gap: 1rem;
  color: #fff;
  height: 42px;
  padding: 0.5rem 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.style__button--RnM4U:hover {
  background-color: #1287b8;
}
.style__button--RnM4U:focus {
  background-color: #095678;
}
.style__button--RnM4U:active {
  background-color: #095678;
}
.style__button--RnM4U:disabled {
  background-color: rgba(12, 13, 13, 0.08);
  color: rgba(6, 60, 89, 0.25);
}
.style__secondary--YhEUZ {
  background-color: #fff;
  border: 1px solid #888c91;
  color: #0c0d0d;
}
.style__secondary--YhEUZ:hover {
  background-color: #f9fafa;
}
.style__secondary--YhEUZ:focus {
  background-color: #f1f2f4;
}
.style__secondary--YhEUZ:active {
  background-color: #f1f2f4;
}
.style__secondary--YhEUZ:disabled {
  background-color: #fff;
}
.style__tertiary--_IRNQ {
  background-color: transparent;
  color: #000;
}
.style__tertiary--_IRNQ:hover {
  background-color: #95999d;
}
.style__tertiary--_IRNQ:focus {
  background-color: #afb2b6;
}
.style__tertiary--_IRNQ:active {
  background-color: #cacdce;
}
.style__tertiary--_IRNQ:disabled {
  background-color: #fff;
}
.style__fullWidth--dF_1P {
  width: calc(100% - 1rem);
  margin: 1rem;
}
.style__storybook--QnrSn {
  background-color: #1287b8;
}
`, "",{"version":3,"sources":["webpack://./../components/src/Button/style.less"],"names":[],"mappings":"AAGA;EAEI,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;AAHJ;AAKI;EACE,iCAAA;EACA,0BAAA;AAHN;AAMI;EACE,iCAAA;EACA,0BAAA;AAJN;AAOI;EACE,iCAAA;EACA,0BAAA;AALN;AAvBA;EAiCI,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;AASI;EACE,yBAAA;AAPN;AAUI;EACE,yBAAA;AARN;AAWI;EACE,yBAAA;AATN;AAYI;EACE,wCAAA;EACA,4BAAA;AAVN;AAlDA;EAiEI,sBAAA;EACA,yBAAA;EACA,cAAA;AAZJ;AAcI;EACE,yBAAA;AAZN;AAeI;EACE,yBAAA;AAbN;AAgBI;EACE,yBAAA;AAdN;AAiBI;EACE,sBAAA;AAfN;AAnEA;EAuFI,6BAAA;EACA,WAAA;AAjBJ;AAmBI;EACE,yBAAA;AAjBN;AAoBI;EACE,yBAAA;AAlBN;AAqBI;EACE,yBAAA;AAnBN;AAsBI;EACE,sBAAA;AApBN;AAnFA;EA4GI,wBAAA;EACA,YAAA;AAtBJ;AAvFA;EAiHI,yBAAA;AAvBJ","sourcesContent":["@import '../colors';\n@import '../spacing';\n\n:local {\n  .newButton {\n    background-color: @color-white;\n    border-radius: @spacing-50;\n    cursor: pointer;\n    outline: none;\n    border: none;\n    color: @color-asphalt-grey-020;\n    height: 42px;\n    padding: @spacing-50 @spacing-100;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-transform: none;\n    text-decoration: none;\n\n    &:hover {\n      background-color: @color-white !important;\n      text-decoration: underline;\n    }\n\n    &:focus {\n      background-color: @color-white !important;\n      text-decoration: underline;\n    }\n\n    &:active {\n      background-color: @color-white !important;\n      text-decoration: underline;\n    }\n  }\n\n  .button {\n    background-color: @color-light-blue-070;\n    border-radius: @spacing-50;\n    cursor: pointer;\n    outline: none;\n    border: none;\n    gap: @spacing-100;\n    color: @color-white;\n    height: 42px;\n    padding: @spacing-50 @spacing-75;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      background-color: @color-light-blue-050;\n    }\n\n    &:focus {\n      background-color: @color-light-blue-030;\n    }\n\n    &:active {\n      background-color: @color-light-blue-030;\n    }\n\n    &:disabled {\n      background-color: fade(@color-asphalt-grey-005, 8%);\n      color: fade(@color-light-blue-020, 25%);\n    }\n  }\n\n  .secondary {\n    background-color: @color-white;\n    border: 1px solid @color-asphalt-grey-055;\n    color: @color-asphalt-grey-005;\n\n    &:hover {\n      background-color: @color-asphalt-grey-099;\n    }\n\n    &:focus {\n      background-color: @color-asphalt-grey-095;\n    }\n\n    &:active {\n      background-color: @color-asphalt-grey-095;\n    }\n\n    &:disabled {\n      background-color: @color-white;\n    }\n  }\n\n  .tertiary {\n    background-color: transparent;\n    color: @color-black;\n\n    &:hover {\n      background-color: @color-asphalt-grey-060;\n    }\n\n    &:focus {\n      background-color: @color-asphalt-grey-070;\n    }\n\n    &:active {\n      background-color: @color-asphalt-grey-080;\n    }\n\n    &:disabled {\n      background-color: @color-white;\n    }\n  }\n\n  .fullWidth {\n    width: calc(100% - @spacing-100);\n    margin: @spacing-100;\n  }\n\n  .storybook {\n    background-color: @color-light-blue-050;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newButton": `style__newButton--YteMz`,
	"button": `style__button--RnM4U`,
	"secondary": `style__secondary--YhEUZ`,
	"tertiary": `style__tertiary--_IRNQ`,
	"fullWidth": `style__fullWidth--dF_1P`,
	"storybook": `style__storybook--QnrSn`
};
export default ___CSS_LOADER_EXPORT___;
